/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import {
  RankedTester,
  rankWith,
  RendererProps,
  UISchemaElement,
  uiTypeIs,
} from "@jsonforms/core";
import { withJsonFormsLayoutProps } from "@jsonforms/react";
import { StatusLight } from "@adobe/react-spectrum";

// Lodash
import { get } from "lodash";

// Redux
import { useSelector } from "react-redux";
import { evaluateContextRule, extractPath } from "../utils/commonUtils";

export const statusLightRendererTester: RankedTester = rankWith(
  4,
  uiTypeIs("StatusLight")
);

type optionsType = {
  label?: string;
  variant?:
    | "positive"
    | "negative"
    | "notice"
    | "info"
    | "neutral"
    | "celery"
    | "chartreuse"
    | "yellow"
    | "magenta"
    | "fuchsia"
    | "purple"
    | "indigo"
    | "seafoam";
  value?: any;
  style?: any;
};

function StatusLightRenderer({ uischema, visible }: RendererProps) {
  const optionsSchema = uischema as UISchemaElement;
  const { label, variant, value, style } = optionsSchema.options as optionsType;
  let val = useSelector((state: any) => get(state?.reduxState, value));
  // let val = label;
  if (val === undefined) {
    val = label;
  }
  const getStatusVariant = (status: any) => {
    let statusVal: any = "info";

    switch (status?.toLowerCase()) {
      case "report synced":
      case "active":
        statusVal = "positive";
        break;
      case "report failed":
      case "cancelled":
      case "sync failed":
      case "inactive":
        statusVal = "negative";
        break;
      case "generating report":
      case "draft":
        statusVal = "neutral";
        break;
      case "title":
      case "sync in progress":
      case "report ready":
        statusVal = "info";
        break;
      default:
        break;
    }
    return statusVal;
  };

  // Determine if the component should be visible
  let componentVisibility = visible;

  // If there is a context rule, evaluate it and use that visibility rule instead.
  if (uischema.options?.contextRule) {
    // grab the scope from the contextRule
    const scope = extractPath(uischema.options?.contextRule?.condition?.scope);
    // get the redux store state based on the scope provided
    const reduxState = useSelector((state: any) =>
      get(state?.reduxState, scope)
    );
    componentVisibility = evaluateContextRule(
      uischema.options?.contextRule,
      reduxState
    )?.visible;
  }

  return (
    <StatusLight
      data-testid="statusLight"
      variant={variant || getStatusVariant(val)}
      UNSAFE_style={style}
      isHidden={!componentVisibility}
    >
      {val}
    </StatusLight>
  );
}

export default withJsonFormsLayoutProps(StatusLightRenderer);
